import {Component, Input, OnInit} from '@angular/core';
import {NgClass, NgForOf} from "@angular/common";
import {QuestionItem} from "../../models/question-item.model";
import {QuestionType} from "../popups/question-list/question-type.enum";

@Component({
  selector: 'app-distribution-bar',
  standalone: true,
  imports: [
    NgForOf,
    NgClass
  ],
  templateUrl: './distribution-bar.component.html',
  styleUrl: './distribution-bar.component.scss'
})
export class DistributionBarComponent implements OnInit {
  @Input() data: QuestionItem[] = [];
  protected distribution: DistributionItem[] = []

  ngOnInit() {
    let sum = this.data.length;
    let options = this.data.map(x => x.state).filter((value, index, array) => array.indexOf(value) === index).sort((a, b) => a - b);
    this.distribution = options.map(x => ({type: x, amount: 0} as DistributionItem));
    this.distribution.forEach(d => d.amount = this.data.filter(x => x.state === d.type).length/sum)
  }

  protected setClass(state: QuestionType): string {
    switch (state) {
      case QuestionType.Ok:
        return 'ok';
      case QuestionType.Nok:
        return 'nok';
      case QuestionType.NotRelevant:
        return 'not-relevant';
      case QuestionType.Unknown:
        return 'unknown';
    }
  }
}

class DistributionItem {
  public amount: number = 0;
  public type: QuestionType = QuestionType.Unknown;
}
